import { render, staticRenderFns } from "./qrlista.vue?vue&type=template&id=4a3972f1&scoped=true&"
import script from "./qrlista.vue?vue&type=script&lang=js&"
export * from "./qrlista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3972f1",
  null
  
)

export default component.exports